<template>
  <el-container class="add-dialog">
    <header>添加
      <i class="iconfont icon-close" @click="dialogClose"></i>
    </header>
    <div class="content">
      <div class="banner">
        <div class="h3">{{theme}}</div>
      </div>
      <div class="form">
        <div class="form-header">基本信息</div>
        <div class="form-content">
          <!-- 名称 (输入框)-->
          <div class="form-item single" v-if="isShowTitle">
            <span class="item-title"><span class="need">*</span>名称</span>
            <div class="item-right">
              <el-input v-model.trim="title" placeholder="请输入(必填)" size="medium" maxlength="16"></el-input>
            </div>
            <div class="err" v-if="err_title"><i class="el-icon-warning"></i>{{err_title}}</div>
          </div>
          <!-- 日期选择器 -->
          <div class="form-item single" v-if="isShowDate">
            <span class="item-title"><span class="need">*</span>日期</span>
            <div class="item-right">
              <el-date-picker
                v-model="dateValue"
                type="date"
                value-format="timestamp"
                placeholder="选择日期">
              </el-date-picker>
            </div>
            <div class="err" v-if="err_date"><i class="el-icon-warning"></i>{{err_date}}</div>
          </div>
          <!-- 描述 (多行文本)-->
          <div class="form-item single" v-if="isShowTextArea">
            <span class="item-title">描述</span>
            <div class="item-right">
              <el-input
                type="textarea"
                :rows="4"
                placeholder="请输入"
                v-model="textarea">
              </el-input>
            </div>
          </div>
          <!-- 视频/列表封面（图片上传）-->
          <div class="form-item single50" v-if="isShowImg">
            <span class="item-title"><span class="need">*</span>视频封面</span>
            <div class="item-right">
              <div class="upload" @click="fileApply($event)"><i class="iconfont icon-Rectangle"></i> 上传图片</div>
              <input type="file" id="fileApply" hidden @change="fileApply($event)" accept="image/*"/>
              <div class="upload-box" v-if="listImg">
                <img class="upload-img" :src="listImg.file_url + '&TOKEN=' + token" alt="">
              </div>
            </div>
            <div class="err" v-if="err_upload"><i class="el-icon-warning"></i>{{err_upload}}</div>
          </div>
          <!-- 视频（附件上传）-->
          <div class="form-item single50" v-if="isShowFile">
            <span class="item-title"><span class="need">*</span>视频文件</span>
            <div class="item-right">
              <div class="upload" @click="fileApply($event,'video')"><i class="iconfont icon-Rectangle"></i> 上传视频</div>
              <input type="file" id="fileApplyVideo" hidden @change="fileApply($event,'video')" accept="video/*"/>
              <div class="upload-box-file" v-if="videoItem">
                <i class="iconfont icon-icon-pc-paper-mp video-icon"></i>
                <span class="info">
                  <p class="first">{{videoItem.file_name}}</p>
                  <p class="second">{{videoItem.file_size | fileSize()}}</p>
                </span>
              </div>
            </div>
            <div class="err" v-if="err_upload_file"><i class="el-icon-warning"></i>{{err_upload_file}}</div>
          </div>
          <!-- 内容（富文本） -->
          <div class="form-item single" v-if="isShowEditor">
            <span class="item-title"><span class="need">*</span>内容</span>
            <div class="item-right">
              <ueditor :editorContent="editorContent" :isEdit="true"></ueditor>
            </div>
            <div class="err" v-if="err_editor"><i class="el-icon-warning"></i>{{err_editor}}</div>
          </div>
        </div>
      </div>
    </div>
    <footer>
      <el-button @click="dialogClose()">取 消</el-button>
      <el-button type="primary" @click="allSelf()">保 存</el-button>
    </footer>
  </el-container>
</template>
<script>
import ueditor from '@/common/components/ueditor.vue'
import { mapState, mapMutations } from 'vuex'
export default {
  components: {
    ueditor
  },
  // theme：弹窗主题
  // parentId : 父节点id（帮助文档才有）
  // menuId : 菜单id（视频/案例教程才有）
  props: ['parentId', 'menuId'],
  data () {
    return {
      isShowTitle: true, // 名称字段
      isShowDate: false, // 日期字段
      isShowImg: false, // 上传图片字段
      isShowEditor: false, // 富文本字段
      isShowTextArea: false, // 多行文本字段
      isShowFile: false, // 附件字段
      title: '', // 标题
      dateValue: '', // 日期
      siteValue: 1, // 发布网站
      siteList: [{value: 1, label: '官网'}, {value: 2, label: '定制网'}],
      typeValue: '', // 分类
      typeList: [],
      token: JSON.parse(sessionStorage.getItem('requestHeader')).TOKEN,
      listImg: '', // 列表图片
      videoItem: '', // 视频
      editorHTML: '', // 编辑器内容
      editorContent: '', // 设置编辑器内容
      textarea: '', // 多行文本
      err_title: '', // 标题
      err_date: '', // 日期
      err_upload: '', // 列表图片
      err_upload_file: '', // 附件
      err_editor: '', // 内容
      currentId: ''
    }
  },
  created () {
    if (this.theme === '帮助' && !this.vedioTeachDialog && !this.caseExplainDialog && !this.faqDialog && !this.updateLogDialog) {
      // 帮助文档
      this.isShowEditor = true
    } else if (this.vedioTeachDialog) {
      // 教学视频
      this.isShowImg = true
      this.isShowTextArea = true
      this.isShowFile = true
    } else if (this.caseExplainDialog) {
      // 案例详解
      this.isShowImg = true
      this.isShowFile = true
      this.isShowEditor = true
    } else if (this.faqDialog) {
      // 常见问题
      this.isShowEditor = true
    } else if (this.updateLogDialog) {
      // 更新日志
      this.isShowTitle = false
      this.isShowDate = true
      this.isShowEditor = true
    }
  },
  mounted () {
    this.$bus.off('editorContents')
    this.$bus.on('editorContents', res => {
      this.editorHTML = res
    })
    // 帮助文档-打开编辑
    this.$bus.off('openEdit')
    this.$bus.on('openEdit', (res1, res2, id) => {
      this.currentId = id
      this.title = res1
      this.editorContent = res2
    })
    if (this.editDetail !== null) {
      if (this.vedioTeachDialog) {
        // 视频教程-打开编辑
        this.currentId = this.editDetail.id
        this.title = this.editDetail.title
        this.textarea = this.editDetail.content
        this.listImg = this.editDetail.images[0]
        this.videoItem = this.editDetail.videos[0]
      } else if (this.caseExplainDialog) {
        // 案例详解-打开编辑
        this.currentId = this.editDetail.id
        this.title = this.editDetail.title
        this.editorContent = this.editDetail.content
        this.listImg = this.editDetail.images[0]
        this.videoItem = this.editDetail.videos[0]
      } else if (this.faqDialog) {
        // 常见问题-打开编辑
        this.currentId = this.editDetail.id
        this.title = this.editDetail.title
        this.editorContent = this.editDetail.content
      } else if (this.updateLogDialog) {
        // 更新日志-打开编辑
        console.log(this.editDetail, '更新日志-打开编辑')
        this.currentId = this.editDetail.id
        this.dateValue = this.editDetail.title
        this.editorContent = this.editDetail.content
      }
    }
  },
  filters: {
    // 文件大小
    fileSize (value, empty) {
      value = parseInt(value)
      let kb = value / 1024
      let mb = value / 1024 / 1024
      let gb = value / 1024 / 1024 / 1024
      var math = function (num) {
        return (Math.ceil(num * 10)) / 10
      }
      if (!gb) {
        return empty
      } else if (gb > 1024) {
        return (gb / 1024) + 'T'
      } else if (mb > 1024) {
        return math(mb / 1024) + 'G'
      } else if (kb > 1024) {
        return math(kb / 1024) + 'M'
      } else if (value > 1024) {
        return math(kb) + 'kb'
      } else {
        return '1kb'
      }
    }
  },
  methods: {
    // 上传文件
    fileApply (e, type) {
      if (type === 'video') {
        document.getElementById('fileApplyVideo').click()
      } else {
        document.getElementById('fileApply').click()
      }
      if (!e.target.value) {
        console.log('为空！！！')
        return
      }
      if (e.target.files[0].size > (104857600 * 5)) {
        this.$message({
          showClose: true,
          type: 'error',
          message: '上传视频最大不超过500M!'
        })
        return
      }

      var file = e.target.files[0]
      // var fileType = file.type
      // if (fileType.split('/')[0] === 'image') {
      let formdata = new FormData()
      formdata.append('userlogo', file)
      formdata.append('bean', 'user')
      this.$http.imageUpload(formdata, 'Loading').then((res) => {
        res.map((item) => {
          if (type === 'video') {
            this.videoItem = item
          } else {
            this.listImg = item
          }
        })
      })
      // }
      e.target.value = ''
    },
    allSelf () {
      if (this.theme === '帮助' && !this.vedioTeachDialog && !this.caseExplainDialog && !this.faqDialog && !this.updateLogDialog) {
        // 帮助文档
        this.helpSave()
      } else if (this.vedioTeachDialog) {
        // 教学视频
        this.videoSave()
      } else if (this.caseExplainDialog) {
        // 案例详解
        this.caseSave()
      } else if (this.faqDialog) {
        // 常见问题
        this.faqSave()
      } else if (this.updateLogDialog) {
        // 更新日志
        this.updateLogSave()
      }
    },
    // 更新日志提交数据
    updateLogSave () {
      let b = this.dataTraversal()
      if (b) {
        let obj = {
          'title': this.dateValue, // 日期
          'content': this.editorHTML, // textarea
          'menu_type': 5,
          'menu_id': -2
        }
        if (this.currentId !== '') {
          // 编辑
          obj.id = this.currentId
          this.$http.updateDoc(obj).then(res => {
            this.$message({
              showClose: true,
              type: 'success',
              message: '保存成功!'
            })
            // 关窗(刷新列表)
            this.setUpdateLogDialog(false) // 关闭更新日志弹窗
          })
        } else {
          // 新增
          this.$http.addDoc(obj).then(res => {
            this.$message({
              showClose: true,
              type: 'success',
              message: '保存成功!'
            })
            // 关窗(刷新列表)
            this.setUpdateLogDialog(false) // 关闭更新日志弹窗
          })
        }
      }
    },
    // 常见问题提交数据
    faqSave () {
      let b = this.dataTraversal()
      if (b) {
        let obj = {
          'title': this.title, // 名称
          'content': this.editorHTML, // textarea
          'menu_type': 4,
          'menu_id': -1
        }
        if (this.currentId !== '') {
          // 编辑
          obj.id = this.currentId
          this.$http.updateDoc(obj).then(res => {
            this.$message({
              showClose: true,
              type: 'success',
              message: '保存成功!'
            })
            // 关窗(刷新列表)
            this.setFaqDialog(false) // 关闭视频教程弹窗
          })
        } else {
          // 新增
          this.$http.addDoc(obj).then(res => {
            this.$message({
              showClose: true,
              type: 'success',
              message: '保存成功!'
            })
            // 关窗(刷新列表)
            this.setFaqDialog(false) // 关闭视频教程弹窗
          })
        }
      }
    },
    // 案例详解提交数据
    caseSave () {
      let b = this.dataTraversal()
      if (b) {
        let arr = []
        arr.push(this.listImg)
        let arr1 = []
        arr1.push(this.videoItem)
        let obj = {
          'title': this.title, // 名称
          'content': this.editorHTML, // textarea
          'menu_type': 3,
          'menu_id': this.menuId,
          'images': arr, // jsonArray
          'videos': arr1 // jsonArray
        }
        if (this.currentId !== '') {
          // 编辑 newsUpdateNews
          obj.id = this.currentId
          this.$http.updateDoc(obj).then(res => {
            this.$message({
              showClose: true,
              type: 'success',
              message: '保存成功!'
            })
            // 关窗(刷新列表)
            this.setCaseExplainDialog(false) // 关闭视频教程弹窗
          })
        } else {
          // 新增
          this.$http.addDoc(obj).then(res => {
            this.$message({
              showClose: true,
              type: 'success',
              message: '保存成功!'
            })
            // 关窗(刷新列表)
            this.setCaseExplainDialog(false) // 关闭视频教程弹窗
          })
        }
      }
    },
    // 帮助文档提交数据
    helpSave () {
      let b = this.dataTraversal()
      if (b) {
        let obj = {
          'menu_type': 1, // 是 int 1帮助文档，2、视频，3案例
          'menu_name': this.title, // 是 string 菜单名称
          'content': this.editorHTML, // 是 string 菜单内容帮助文档才会有
          'parent_id': this.parentId // 否 Long 父节点id，帮助文档才会有，视频，案例没有
        }
        if (this.currentId !== '') {
          // 编辑
          obj.id = this.currentId
          this.$http.updateMenu(obj).then(res => {
            this.$message({
              showClose: true,
              type: 'success',
              message: '保存成功!'
            })
            // 关窗(刷新列表)
            this.dialogClose('edit')
          })
        } else {
          // 新增
          this.$http.helpCenterAddMenu(obj).then(res => {
            this.$message({
              showClose: true,
              type: 'success',
              message: '保存成功!'
            })
            // 关窗(刷新列表)
            this.dialogClose('refreshList')
          })
        }
      }
    },
    // 视频教程提交数据
    videoSave () {
      let b = this.dataTraversal()
      if (b) {
        let arr = []
        arr.push(this.listImg)
        let arr1 = []
        arr1.push(this.videoItem)
        let obj = {
          'title': this.title, // 名称
          'content': this.textarea, // textarea
          'menu_type': 2,
          'menu_id': this.menuId,
          'images': arr, // jsonArray
          'videos': arr1 // jsonArray
        }
        if (this.currentId !== '') {
          // 编辑
          obj.id = this.currentId
          this.$http.updateDoc(obj).then(res => {
            this.$message({
              showClose: true,
              type: 'success',
              message: '保存成功!'
            })
            // 关窗(刷新列表)
            this.setVedioTeachDialog(false) // 关闭视频教程弹窗
          })
        } else {
          // 新增
          this.$http.addDoc(obj).then(res => {
            this.$message({
              showClose: true,
              type: 'success',
              message: '保存成功!'
            })
            // 关窗(刷新列表)
            this.setVedioTeachDialog(false) // 关闭视频教程弹窗
          })
        }
      }
    },
    /** 数据遍历 */
    dataTraversal () {
      this.err_title = ''
      this.err_date = ''
      this.err_site = ''
      this.err_type = ''
      this.err_upload = ''
      this.err_upload_file = ''
      this.err_editor = ''
      if (this.theme === '帮助' && !this.vedioTeachDialog && !this.caseExplainDialog && !this.faqDialog && !this.updateLogDialog) {
        // 帮助文档
        if (!this.title) {
          this.err_title = '标题不能为空'
          return false
        }
        if (!this.editorHTML) {
          this.err_editor = '内容不能为空'
          return false
        }
      } else if (this.vedioTeachDialog) {
        // 视频教程
        if (!this.title) {
          this.err_title = '标题不能为空'
          return false
        }
        if (!this.listImg) {
          this.err_upload = '视频封面不能为空'
          return false
        }
        if (!this.videoItem) {
          this.err_upload_file = '视频文件不能为空'
          return false
        }
      } else if (this.caseExplainDialog) {
        // 案例详解
        if (!this.title) {
          this.err_title = '标题不能为空'
          return false
        }
        if (!this.listImg) {
          this.err_upload = '视频封面不能为空'
          return false
        }
        if (!this.videoItem) {
          this.err_upload_file = '视频文件不能为空'
          return false
        }
        if (!this.editorHTML) {
          this.err_editor = '内容不能为空'
          return false
        }
      } else if (this.faqDialog) {
        // 常见问题
        if (!this.title) {
          this.err_title = '标题不能为空'
          return false
        }
        if (!this.editorHTML) {
          this.err_editor = '内容不能为空'
          return false
        }
      } else if (this.updateLogDialog) {
        // 更新日志
        if (!this.dateValue) {
          this.err_date = '日期不能为空'
          return false
        }
        if (!this.editorHTML) {
          this.err_editor = '内容不能为空'
          return false
        }
      }
      return true
    },
    // 关闭弹窗
    dialogClose (tag) {
      this.$bus.emit('closeAddNews', tag) // 关闭帮助文档弹窗
      this.setVedioTeachDialog(false) // 关闭视频教程弹窗
      this.setCaseExplainDialog(false) // 关闭案例详解弹窗
      this.setFaqDialog(false) // 关闭常见问题弹窗
      this.setUpdateLogDialog(false) // 关闭更新日志弹窗
    },
    ...mapMutations({
      setVedioTeachDialog: 'VEDIO_TEACH_DIALOG', // 开关视频教程弹窗
      setCaseExplainDialog: 'CASE_EXPLAIN_DIALOG', // 开关案例详解弹窗
      setFaqDialog: 'FAQ_DIALOG', // 开关常见问题弹窗
      setUpdateLogDialog: 'UPDATE_LOG_DIALOG' // 开关更新日志弹窗
    })
  },
  computed: {
    ...mapState({
      vedioTeachDialog: state => state.vedioTeach.vedioTeachDialog, // 视频教程弹窗
      caseExplainDialog: state => state.caseExplain.caseExplainDialog, // 案例详解弹窗
      faqDialog: state => state.faq.faqDialog, // 常见问题弹窗
      updateLogDialog: state => state.updateLog.updateLogDialog, // 更新日志弹窗
      theme: state => state.helpDocCreate.theme, // 主题
      editDetail: state => state.helpDocCreate.editDetail // 编辑详情数据
    })
  }
}
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/page/help/help-document-create.vue